import { Box } from '@mui/material'
import { formatDateTime } from '../../../app/utils'
import { MRT_ColumnDef as MRTColumnDef } from 'material-react-table'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import MRTDataGridv2 from '../../../components/MRTDataGrid/MRTDataGridv2'
import { messages } from '../messages'
import { UnassignedTransitDetail } from '../types'
import EmbeddedContainer from './EmbeddedContainer'

type EmbeddedTransitDetailsTableProps = {
  transitDetails: UnassignedTransitDetail[]
}

const EmbeddedTransitDetailsTable = ({ transitDetails }: EmbeddedTransitDetailsTableProps) => {
  const { formatMessage } = useIntl()

  const columns = useMemo<MRTColumnDef<UnassignedTransitDetail>[]>(() => {
    return [
      {
        accessorFn: (row) => row.transportModeName ?? formatMessage(messages.notAvailable),
        header: formatMessage(messages.modeOfTransit),
      },
      {
        accessorFn: (row) =>
          row.isCrossBorder === true
            ? formatMessage(messages.yes)
            : row.isCrossBorder === false
              ? formatMessage(messages.no)
              : formatMessage(messages.notAvailable),
        header: formatMessage(messages.crossBorder),
      },
      {
        accessorFn: (row) =>
          row.fulfilmentRequired ? formatMessage(messages.yes) : formatMessage(messages.no),
        header: formatMessage(messages.fulfilmentRequired),
      },
      {
        accessorFn: (row) => row.preferredCarrierName ?? formatMessage(messages.notAvailable),
        header: formatMessage(messages.preferredCarrier),
      },
      {
        accessorFn: (row) => row.preBookedTransitIdentifier ?? formatMessage(messages.notAvailable),
        header: formatMessage(messages.preBookedTransitIdentifier),
      },
      {
        accessorFn: (row) =>
          row.scheduledDeparture
            ? formatDateTime(row.scheduledDeparture)
            : formatMessage(messages.notAvailable),
        header: formatMessage(messages.scheduledDeparture),
      },
      {
        accessorFn: (row) =>
          row.scheduledArrival
            ? formatDateTime(row.scheduledArrival)
            : formatMessage(messages.notAvailable),
        header: formatMessage(messages.scheduledArrival),
      },
    ]
  }, [formatMessage])

  return (
    <EmbeddedContainer>
      <Box
        sx={{
          width: '100%',
          height: '100%',
        }}
      >
        <MRTDataGridv2
          columns={columns}
          data={transitDetails || []}
          enableColumnActions={false}
          enableColumnFilters={false}
          enablePagination={false}
          enableSorting={false}
          enableBottomToolbar={false}
          enableTopToolbar={false}
          positionActionsColumn='last'
        />
      </Box>
    </EmbeddedContainer>
  )
}

export default EmbeddedTransitDetailsTable
